{
  "de": {
    "curriculum": {
      "confirmDelete": {
        "confirm": "Ja, löschen",
        "text": "Möchtest du „{filename}“ wirklich löschen? Die Datei und die durchsuchbaren Lehrplan-Inhalte werden entfernt.",
        "title": "Lehrplan löschen?"
      },
      "confirmedUseful": "Lehrplan wurde für die Suche bestätigt.",
      "confirmUseful": "Für Lehrplan-Suche bestätigen",
      "confirmUsefulFailed": "Lehrplan konnte nicht bestätigt werden.",
      "configure": "Lehrplan-Einstellungen öffnen",
      "delete": "Lehrplan löschen",
      "deleted": "Lehrplan wurde gelöscht.",
      "deleteFailed": "Lehrplan konnte nicht gelöscht werden.",
      "empty": "Noch keine eigenen Lehrplandokumente hochgeladen.",
      "documentKindDescriptions": {
        "cross_curricular_framework": "Ein fächerübergreifender Rahmenplan, zum Beispiel für Medienbildung oder digitale Kompetenzen.",
        "curriculum_guidance": "Ein Leitfaden, Kommentar oder Unterstützungsmaterial zur Arbeit mit einem Lehrplan.",
        "general_curriculum_part": "Ein allgemeiner Lehrplanteil ohne einzelnes Fach, zum Beispiel mit Grundsätzen oder übergreifenden Zielen.",
        "non_curriculum": "Diese Datei wurde nicht als Lehrplandokument erkannt.",
        "presentation_or_training_material": "Präsentations- oder Fortbildungsmaterial über Lehrpläne, aber kein eigentlicher Lehrplan.",
        "subject_curriculum": "Ein fachbezogener Lehrplan oder Fachanforderungen für ein konkretes Schulfach.",
        "unknown": "Der Dokumenttyp konnte nicht zuverlässig erkannt werden."
      },
      "documentKindLabels": {
        "cross_curricular_framework": "Rahmenplan",
        "curriculum_guidance": "Leitfaden",
        "general_curriculum_part": "Allgemeiner Lehrplanteil",
        "non_curriculum": "Kein Lehrplan",
        "presentation_or_training_material": "Präsentation / Fortbildung",
        "subject_curriculum": "Fachlehrplan",
        "unknown": "Unklar"
      },
      "fields": {
        "country": "Land",
        "documentKind": "Dokumenttyp",
        "gradeLevel": "Klassenstufe",
        "region": "Region",
        "schoolType": "Schulart",
        "subject": "Fach",
        "title": "Titel"
      },
      "hints": {
        "customCategoryValue": "Nicht gefunden? Eigenen Wert eingeben."
      },
      "loading": "Lehrpläne werden geladen...",
      "needsReview": "Wir konnten dieses Dokument nicht eindeutig einem Lehrplan, Fach, einer Klassenstufe oder Schulart zuordnen. Es ist daher wahrscheinlich für die Lehrplan-Suche nur eingeschränkt hilfreich. Bitte ergänze die Angaben oder lösche die Datei.",
      "notSet": "Nicht gesetzt",
      "officialAvailable": "Offizielle Lehrplandaten sind für diese Länder oder Regionen verfügbar: {locations}. Eigene Uploads ergänzen fehlende oder eigene Ausschnitte.",
      "officialMissing": "Für deine Auswahl sind noch keine offiziellen Lehrplandaten verfügbar. Du kannst eigene Lehrplandokumente hochladen.",
      "placeholders": {
        "selectOrAddOptions": "Suchen, auswählen oder eigenen Wert eingeben"
      },
      "saved": "Lehrplan-Metadaten gespeichert.",
      "states": {
        "classification_failed": "Automatische Erkennung fehlgeschlagen",
        "classifying": "Lehrplan wird analysiert",
        "file_processing_failed": "Datei konnte nicht gelesen werden",
        "import_failed": "Import fehlgeschlagen",
        "indexing": "Wird in die Lehrplansuche übernommen",
        "needs_review": "Überprüfung nötig",
        "official": "Offizieller Lehrplan",
        "processing_file": "Datei wird verarbeitet",
        "searchable": "Durchsuchbar"
      },
      "statusDescriptions": {
        "classification_failed": "Die automatische Erkennung konnte Fach, Klassenstufe oder Schulart nicht zuverlässig bestimmen. Du kannst die Angaben manuell bearbeiten.",
        "classifying": "Der Lehrplantext wird analysiert, damit Fach, Klassenstufe und Schulart vorgeschlagen werden können.",
        "file_processing_failed": "Die Datei konnte nicht gelesen werden. Bitte lade eine andere PDF-, DOCX- oder Textdatei hoch.",
        "import_failed": "Der Lehrplan konnte nicht in die Lehrplansuche übernommen werden. Du kannst die Metadaten prüfen und erneut speichern.",
        "indexing": "Die Datei wurde erkannt und wird gerade für die Lehrplansuche vorbereitet.",
        "needs_review": "Die Datei ist technisch verarbeitet, aber die Lehrplan-Metadaten sind unklar oder unvollständig.",
        "official": "Für diesen Bereich sind offizielle Lehrplandaten verfügbar.",
        "processing_file": "Die Datei wird gelesen und der Text wird extrahiert.",
        "searchable": "Der Lehrplan ist indexiert und kann von der Lehrplansuche verwendet werden."
      },
      "title": "Lehrpläne",
      "upload": "Lehrplan hochladen",
      "uploaded": "Lehrplan wurde hochgeladen und wird verarbeitet.",
      "uploadFailed": "Lehrplan konnte nicht hochgeladen werden."
    }
  }
}
